import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IStateListItem } from '@/api/types-fip'

export const defaultFipStateData: IStateListItem = {
  fipsState: 0,
  stateAbbrv: '',
  stateName: ''
}

export interface IFipStates {
  FipStateList: IStateListItem[]
  FipStateSelected: (IStateListItem | null)
}

@Module({ dynamic: true, store, name: 'FipStates' })
class FipStates extends VuexModule implements IFipStates {
  public FipStateList: IStateListItem[] = []
  public FipStateSelected: IStateListItem | null = null

  @Mutation
  private DEL_ALL_ITEMS() {
    this.FipStateList = []
  }

  @Mutation
  private LOAD_ITEMS(fipStates: IStateListItem[]) {
    this.FipStateList = fipStates
  }

  @Mutation
  private SET_SELECTED_ITEM(item: IStateListItem) {
    this.FipStateSelected = item
  }

  // GETTERS
  get cachedFipStates() {
    return this.FipStateList
  }

  @Action
  public loadFipStates(fipStates: IStateListItem[]) {
    this.DEL_ALL_ITEMS()
    this.LOAD_ITEMS(fipStates)
  }

  @Action
  public selectItem(item: IStateListItem) {
    this.SET_SELECTED_ITEM(item)
  }
}

export const FipStateModule = getModule(FipStates)
